export default __webpack_public_path__ + "static/media/django.7161fa08.png";